import { useEffect, useState, useMemo, useRef } from "react";
import {getdashboarddetailseditor, updatedashboardwidgetlist} from '../../../Restclient/datacollection';
import { WidthProvider, Responsive } from "react-grid-layout";
import 'react-grid-layout/css/styles.css'
import _ from "lodash";
import Widgetcard from "./Widgetcardedit";
import { useSelector, useDispatch } from 'react-redux';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import { setEditWidgetMode, setEditWidgetId } from "../../../store/cofig_data";

export default function Dashboardconfpage (props) {
    const ResponsiveReactGridLayout = useMemo(() => WidthProvider(Responsive), []);
    const widgettype = useSelector((state) => state.configdata.editwidgetselect);
    const basicprops = useSelector((state) => state.configdata.editbasicprops);
    const extendedprops = useSelector((state) => state.configdata.editextendedprops);
    const editwidgetmode = useSelector((state) => state.configdata.editwidgetmode);
    const editingWidgetId = useSelector((state) => state.configdata.editwidgetid); 
    const theme = useSelector((state) => state.themedata.theme)

    const [widgetslist, setWidgetlist] = useState([])
    const [msgdialog, setMsgdialog] = useState(false)
    const [msg, setMsg] = useState("")

    const [addwidgetflag, setAddwidgetflag] = useState(false);
    const [editdialog, setEditdialog] = useState(false); // <-- Add state for edit dialog

    const justUpdatedRef = useRef(false);
    const callbackdashboarddata = (res) => {

        if(res?.dashboardjson?.DashboardJSON?.hasOwnProperty('widgetlist')) {
            setWidgetlist(res?.dashboardjson?.DashboardJSON?.widgetlist)
        }
    }
    const callbackresponcewidgetlistupdate = (res) => {
        if(res.status === "done") {
            setMsg("widgets are added")
        } else {
            setMsg("Failed to add widgets")
        
        }
        setMsgdialog(true)
    }

    const handledeletewidget = (widgetid) => {
      
        var oldwidgetlist = [...widgetslist]

        var finalwlist = []
        for(let i=0; i<oldwidgetlist.length; i++) {
            if(oldwidgetlist[i].id === widgetid) {

            } else {
                finalwlist.push(oldwidgetlist[i])
            }
        }
        setWidgetlist(finalwlist)
    }

     const generatePage = (widgetlist) => {
        if (!widgetlist || !widgetlist.props || !widgetlist.props.basic) {
        return null;
         }

      const handleAddWidgetFlag = () => {
        setAddwidgetflag(true);
       };

        var obj = {
            i: "",
            x: 0,
            y: 0,
            w: 0,
            h: 0,
            minW: 1,
            minH: 1,
            maxH: 20,
        };
        var widgetprops = widgetlist["props"]["basic"]

        obj = {
            i: String(widgetlist?.id),  
            x: parseInt(widgetprops?.size?.x),
            y: parseInt(widgetprops?.size?.y),
            w: parseInt(widgetprops?.size?.width),
            h: parseInt(widgetprops?.size?.height),
            minW: 1,
            minH: 1,
            maxH: 20,
        };
        return (
            <div key={widgetlist.id} data-grid={obj} >
                <Widgetcard
                    widgetdprops={widgetlist}
                    maxwidgetflag={false}
                    deletecallback={handledeletewidget}
                    callbackupdateaddflag={handleAddWidgetFlag}
                    onEditClick={() => handleeditclick(widgetlist.id)} // Pass the correct id here
                />
            </div>
        );

    }
    
    useEffect(() => {
        getdashboarddetailseditor(props.dashboarddetails.key, callbackdashboarddata)
    },[])

    const dispatch = useDispatch();

    useEffect(() => {
        if (addwidgetflag && !justUpdatedRef.current) {
            let oldwidgetlist = [...widgetslist];
            let basicjson = JSON.parse(basicprops);
            let extendedPropsObj = {};
            try {
                extendedPropsObj = extendedprops ? JSON.parse(extendedprops) : {};
            } catch (e) {
                extendedPropsObj = {};
            }

            if (editwidgetmode === "Edit" && editingWidgetId) {
                // Update existing widget
                oldwidgetlist = oldwidgetlist.map(widget =>
                    String(widget.id) === String(editingWidgetId)
                        ? {
                            ...widget,
                            widgettype: widgettype,
                            props: {
                                basic: basicjson,
                                extended: extendedPropsObj
                            }
                        }
                        : widget
                );
                justUpdatedRef.current = true; // Prevent next run
            } else {
                // Add new widget logic
                let id = 0;
                for (let i = 0; i < oldwidgetlist.length; i++) {
                    if (id < parseInt(oldwidgetlist[i].id)) {
                        id = parseInt(oldwidgetlist[i].id);
                    }
                }
                let x = 0;
                let y = 0;
                if (oldwidgetlist.length > 0) {
                    var lastwidget = oldwidgetlist[oldwidgetlist.length - 1].props.basic.size;
                    if (lastwidget.width + lastwidget.x <= 12) {
                        if (lastwidget.width + lastwidget.x + basicjson.size.width <= 12) {
                            x = parseInt(lastwidget.width) + parseInt(lastwidget.x);
                            y = parseInt(lastwidget.y);
                        } else {
                            x = 0;
                            y = parseInt(lastwidget.y) + parseInt(lastwidget.height);
                        }
                    } else {
                        y = parseInt(lastwidget.y) + parseInt(lastwidget.height);
                        x = 0;
                    }
                }

                basicjson.size.x = x;
                basicjson.size.y = y;
                oldwidgetlist.push({
                    widgettype: widgettype,
                    id: id + 1,
                    props: {
                        basic: basicjson,
                        extended: extendedPropsObj
                    }
                });
                justUpdatedRef.current = true; // Prevent next run
            }

            setWidgetlist(oldwidgetlist);
            props.callbackupdateaddflag();

            // Reset edit mode and id after save
            dispatch(setEditWidgetMode("New"));
            dispatch(setEditWidgetId(null));
            setAddwidgetflag(false);
        } else if (!addwidgetflag) {
            justUpdatedRef.current = false; // Allow next add/edit
        }
    }, [addwidgetflag, basicprops, extendedprops, widgettype, editwidgetmode, editingWidgetId, widgetslist, dispatch])

    useEffect(() => {
        if(props.savedashboard) {
            // Pass raw widgets list; REST client will handle JSON body / legacy fallback
            updatedashboardwidgetlist(props.dashboarddetails.key, widgetslist, callbackresponcewidgetlistupdate)
            props.callbacksavedashboard(false)
        }
    },[props.savedashboard])
    const handleclosemsgdialog = () => {
        setMsgdialog(false)
    }
    const onLayoutChangemainpage = (layout, layouts) => {
        for(let i=0; i<layout.length; i++) {
            for(let j=0; j<widgetslist.length; j++) {
                if(parseInt(layout[i].i) === widgetslist[j].id) {
                    widgetslist[j].props.basic.size.height = layout[i].h
                    widgetslist[j].props.basic.size.width = layout[i].w
                    widgetslist[j].props.basic.size.x = layout[i].x
                    widgetslist[j].props.basic.size.y = layout[i].y
                    break
                }
            }
        }
    }

    const handleeditclick = (widgetId) => {
        dispatch(setEditWidgetMode("Edit"));
        dispatch(setEditWidgetId(widgetId));
        setEditdialog(true);
    };
    
    return(
        <div style={{height: 'calc(100% - 5px)', overflow: 'auto', backgroundColor: 'var(--PrimaryBackground)'}}>
            <ResponsiveReactGridLayout
                breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
                cols={{ lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 }}
                rowHeight={30}
                margin={[5,5]}
                allowOverlap={false}
                resizeHandles= {['se']}
                isResizable= {true}
                isDraggable= {props.dragflag}
                onLayoutChange={(layout, layouts) => onLayoutChangemainpage(layout, layouts)}
            >
                {_.map(widgetslist, (el) => generatePage(el))}
            </ResponsiveReactGridLayout>
        
            <Dialog
                open={msgdialog}
                onClose={handleclosemsgdialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{ sx: { borderRadius: "0px" } }}
            >
                <DialogTitle id="alert-dialog-title" style={{backgroundColor: theme === 'dark' ? '#000000' : '#EFEFEF', color: theme === 'dark' ? '#FFFFFF' : '#3C3C3C'}}>
                    {"Conformation Info"}
                </DialogTitle>
                <DialogContent style={{backgroundColor: theme === 'dark' ? '#000000' : '#EFEFEF', color: theme === 'dark' ? '#FFFFFF' : '#3C3C3C'}}>
                    {msg}
                </DialogContent>
                <DialogActions style={{backgroundColor: theme === 'dark' ? '#000000' : '#EFEFEF', color: theme === 'dark' ? '#FFFFFF' : '#3C3C3C'}}>
                    <button 
                        style={{
                            padding: '6px 15px',
                            //width: '137px',
                            //height: '35px',
                            backgroundColor: 'transparent',
                            color: '#7E7E7E',
                            //padding: '8px 45px',
                            border: '1px solid',
                            borderColor : '#7E7E7E',
                            borderRadius: '20px',
                            fontSize: '16px',
                            fontWeight: 700,
                            fontFamily: 'Roboto',
                            cursor: 'pointer',
                            marginRight: '10px'
                        }}
                        onClick={handleclosemsgdialog}
                    >
                        Close
                    </button>
                </DialogActions>
            </Dialog>
        
        </div>


    )
}